import { FC, useState, useEffect, MouseEvent } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import Select from '@components/common/Select';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ViewWeekOutlinedIcon from '@material-ui/icons/ViewWeekOutlined';
import CustomSwitch from '@components/CustomSwitch';
import useStore from '@hooks/useStore';

import useStyles from './styles';
import { IToolsConfigItem } from '@store/accountsPayableLink/models/ToolsConfigItem';

export interface IAccountsPayableCustomTools {}
interface IToolsColumnsOptionsItem {
  label: string;
  name: string;
  initialState: boolean;
}

const AccountsPayableCustomTools: FC<IAccountsPayableCustomTools> = () => {
  const css = useStyles();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const { accountsPayableLink } = useStore();
  const { tools, partnerName } = accountsPayableLink;
  const {
    toolsSelectedColumns,
    setToolsSelectedColumns,
    toolsGroupBy,
    setToolsGroupBy,
    toolsConfigGroupBy,
    toolsConfigShowColumns,
  } = tools;

  // Columas
  const [toolsColumnsOptions, setToolsColumnsOptions] = useState<IToolsColumnsOptionsItem[]>([]);
  const [toolsGroupByOptions, setToolsGroupByOptions] = useState<any[]>([]);
  // Agrupar por
  const [selectedColumn, setSelectedColumn] = useState<any>([]);
  const [selectedGroupBy, setSelectedGroupBy] = useState<any>(toolsGroupBy);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectColumn = (column: any) => {
    const columns = selectedColumn;
    if (column.selected === true) {
      // add
      columns.push(column);
    } else {
      const index = columns.findIndex((item: any) => item.name === column.name);
      columns.splice(index, 1);
    }
    setSelectedColumn(columns);
    setToolsSelectedColumns(columns);
  };

  const handleGroupBy = (event: any) => {
    setSelectedGroupBy(event.target.value);
    setToolsGroupBy(event.target.value);
  };

  const handleEmptyGroupBy = () => {
    setSelectedGroupBy('');
    setToolsGroupBy('');
  };

  useEffect(() => {
    const showColumns = toolsConfigShowColumns.map((item) => ({
      ...item,
      label: t(`accountsPayable.columnsName.${item.name}`),
    })) as IToolsConfigItem[];

    const toolsColumnsItems = [] as any;
    for (const item of showColumns) {
      const isActive = toJS(toolsSelectedColumns).filter((data) => data.name === item?.name);
      toolsColumnsItems.push({ ...item, initialState: Object.keys(isActive).length > 0 });
    }

    setToolsColumnsOptions(toolsColumnsItems);

    const toolsGroupBy = toolsConfigGroupBy.map((item) => ({
      ...item,
      label: t(`accountsPayable.columnsName.${item.name}`),
      value: item.name,
    })) as IToolsConfigItem[];

    setToolsGroupByOptions(toolsGroupBy);
  }, [toolsSelectedColumns, toolsConfigGroupBy, toolsConfigShowColumns]);

  if (partnerName !== 'netsuite') {
    return null;
  }

  return (
    <Grid container className={css.toolsContainer}>
      <Grid item xs={12} md={11}>
        <div className={css.groupBySelectContainer}>
          <Select
            handleDeleteSelection={handleEmptyGroupBy}
            onChange={handleGroupBy}
            fullWidth={true}
            value={selectedGroupBy}
            options={toolsGroupByOptions}
            label={'Agrupar por'}
            valueKey={'value'}
            labelKey={'label'}
          />
        </div>
      </Grid>
      <Grid item xs={12} md={1}>
        <Button
          variant="text"
          startIcon={<ViewWeekOutlinedIcon />}
          className={css.columnsButton}
          onClick={handleClick}
        >
          Columnas
        </Button>
        <Menu
          id="columns-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          {toolsColumnsOptions.map((item, index) => {
            return (
              <MenuItem key={index}>
                <CustomSwitch
                  label={item.label}
                  name={item.name}
                  initialState={item.initialState}
                  handleSelectColumn={handleSelectColumn}
                />
              </MenuItem>
            );
          })}
        </Menu>
      </Grid>
    </Grid>
  );
};

export default observer(AccountsPayableCustomTools);
